import React, { useContext, useEffect } from 'react'
import { RequestContext } from '../../../../context/RequestContext';
import { openModal } from '../../../../service/modal-service';
import { BookingCard, BookingFooter, PriceTileGrid, getServiceTheme } from './AirconBookingLayout';
import { buildAirconPriceTables } from '../../../../js/aircon-cost';

// Chemical Hydro Wash (Singapore only), same layout as CassetteAirconBooking:
// one service, so there are no tabs. serviceType is the AirconScope key.
const SERVICE_TYPE = 'chemicalHydroWash'
const UNIT_TYPE = 'Wall'
const HYDRO_CRITERIA = 'Chemical hydro wash (partial dismantling, water-jet rinse)'

// Wall-unit prices for 1-5 units from the pricing profile, the same numbers the
// backend charges (AirconCostCalculator, chemicalHydroBase).
const HYDRO_RATES = buildAirconPriceTables('sg', 5).chemicalHydroWash.map((row) => row.wall.toFixed(2))

export const HydroWashAirconBooking = (props) => {
    const setRequestForm = props.setRequestForm
    const setIsQuickBook = props.setIsQuickBook
    const setIsCustomBook = props.setIsCustomBook
    const setIsShowAirconItemSelection = props.setIsShowAirconItemSelection
    const showJobScope = props.showJobScope
    const currencyCd = props.currencyCd
    const title = props.title || 'Aircon Chemical Hydro Wash'
    const subtitle = props.subtitle

    const { setRequestCriteria, setRequestDescription } = useContext(RequestContext);

    const quickBook = (airconCount) => {
        const criteria = [
            {1: 'Chemical cleaning', criteria: 'Type of service - Chemical cleaning'},
            {2: airconCount.toString(), criteria: "Number of aircon units to be serviced - " + airconCount},
            {3: HYDRO_CRITERIA, criteria: HYDRO_CRITERIA},
            {21: 'Only once', criteria: 'Frequency of service - Only once'},
            {24: 'Wall', criteria: 'Mount type - Wall'}
        ]
        setRequestCriteria(criteria)
        setRequestDescription('Aircon Service')
        setIsQuickBook(true)
        // A quick book is not a custom (picker) booking, whatever came before
        setIsCustomBook(false)
        openModal(setRequestForm)
    }

    useEffect(() => {
        setRequestCriteria([])
        setRequestDescription('')
        setIsQuickBook(false)
        setIsCustomBook(false)
    }, [setIsQuickBook, setIsCustomBook, setRequestCriteria, setRequestDescription])

    const theme = getServiceTheme(SERVICE_TYPE)

    const tiles = HYDRO_RATES.map((rate, i) => ({
        key: `${SERVICE_TYPE}-${i}`,
        label: `${i + 1} AC unit${i > 0 ? 's' : ''}`,
        currencyCd: currencyCd,
        price: rate,
        ariaLabel: `Book chemical hydro wash for ${i + 1} aircon unit${i > 0 ? 's' : ''}`,
        onBook: () => quickBook(i + 1),
    }))

  return (
    // The page already has its own <h1> further down, so the card title stays an h3.
    <BookingCard title={title} subtitle={subtitle} headingAs='h3'>
        <div className='pt-4 pb-2 px-4'>
            <PriceTileGrid
                tiles={tiles}
                theme={theme}
                onMore={() => setIsShowAirconItemSelection(true)}
            />
            <BookingFooter
                theme={theme}
                serviceType={SERVICE_TYPE}
                onShowDetails={() => showJobScope(SERVICE_TYPE, UNIT_TYPE)}
                highlights={['60 days warranty', 'Transport Included']}
            />
        </div>
    </BookingCard>
  )
}
